import { Command } from '@/app/tracking/api';

export interface CompleteSectionCommandPayload {
  sectionId: string;
  meta: {
    title: string
  };
}

export const CompleteSectionCommandName = 'complete-section' as const;

export type CompleteSectionCommand =
      Command<typeof CompleteSectionCommandName, CompleteSectionCommandPayload>;
